import { Component, OnInit, OnDestroy } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { ThemeService } from "./theme/theme.service";
import { Subscription } from "rxjs";
import { Router, Event } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { getBaseUrl } from './services/util.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy{
  title = 'app';
  themeClass: string;
  private themeSub$: Subscription = null;
  envTitle =  ''
  constructor(
    private overlayContainer: OverlayContainer,
    private themeService: ThemeService,
    private router: Router,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    let oldTitle = this.titleService.getTitle()
    switch (getBaseUrl().split("//")[1].split(".")[0]) {
    case "estate-maps-dev": {
      this.envTitle = "DEV"
      break;
    }
    case "estate-maps-qa": {
      this.envTitle = "QA"
      break;
    }
    case "estatemaps": {
      this.envTitle = ""
      break;
    }
    default:{
      this.envTitle = "DEV"
      break;
    }  
  }
    if (this.envTitle) {
      this.titleService.setTitle('('+this.envTitle+ ') ' + oldTitle)
    }
    this.themeSub$ = this.themeService.getSelectedTheme().subscribe(x => {

      if (x) {
        // console.log("Theme change : " + this.themeClass + " > " + x.value)
        // Update the root class and fix up the Overlay stuff
        this.themeClass = x.value;

        // remove old theme class and add new theme class
        // we're removing any css class that contains '-theme' string but your theme classes can follow any pattern
        const overlayContainerClasses = this.overlayContainer.getContainerElement().classList;
        const themeClassesToRemove = Array.from(overlayContainerClasses).filter((item: string) => item.includes('-theme'));
        if (themeClassesToRemove.length) {
          overlayContainerClasses.remove(...themeClassesToRemove);
        }
        overlayContainerClasses.add(this.themeClass);
      }
    });

  }

  ngOnDestroy() {
    this.themeSub$.unsubscribe();
  }

}
